import React from 'react';
import styled from 'styled-components';
import { Title, Container } from '../questionnaire_welcome';
import {
	Card as BaseCard,
	Cards as BaseCards,
	CardTitle as BaseCardTitle,
} from '../questionnaire_body-part-selection';

const CustomTitle = styled(Title)`
	font-size: 32px;
	line-height: 38px;
	margin-top: 80px;
`;

export const CardTitle = styled(BaseCardTitle)`
	color: #464646;
	font-size: 18px;
	line-height: 21px;
	font-weight: 300;
`;

export const Card = styled(BaseCard)`
	padding: 22px 25px;
	max-width: 220px;
`;

export const Cards = styled(BaseCards)`
	max-width: unset;
	width: 100%;
`;

export default ({ cards, setData, nextStep, ...props }) => {
	return (
		<Container>
			<CustomTitle>How long has this been bothering you?</CustomTitle>
			<Cards>
				{cards.map((c) => {
					return (
						<Card
							key={`questionnaire-pain-duration-${c.id}`}
							onClick={() => {
								setData({
									cards: cards.map((oc) => ({
										...oc,
										isSelected: oc.id === c.id,
									})),
								});
								nextStep();
							}}
						>
							<CardTitle>{c.title}</CardTitle>
						</Card>
					);
				})}
			</Cards>
		</Container>
	);
};
